import { render, staticRenderFns } from "./RegimenAssessmentEdit.vue?vue&type=template&id=3001e8e2"
import script from "./RegimenAssessmentEdit.vue?vue&type=script&lang=js"
export * from "./RegimenAssessmentEdit.vue?vue&type=script&lang=js"
import style0 from "./RegimenAssessmentEdit.vue?vue&type=style&index=0&id=3001e8e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports